export default __webpack_public_path__ + "static/media/Träslöjd2.7034d12a.jpeg";